var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgService1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.6 511.6",
    style: {
      enableBackground: "new 0 0 511.6 511.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCD1D9"
    },
    points: "378.875,479.625 170.523,479.625 191.787,373.146 357.58,373.114 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F7FA"
    },
    d: "M511.6,383.7c0,5.901-4.777,10.679-10.663,10.679H10.648c-5.87,0-10.647-4.777-10.647-10.679V42.638 c0-5.886,4.777-10.664,10.647-10.664h490.289c5.886,0,10.663,4.777,10.663,10.664V383.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M10.648,394.379h490.289c5.886,0,10.663-4.777,10.663-10.679V330.43H0V383.7 C0,389.602,4.778,394.379,10.648,394.379z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.623,
    y: 245.14,
    style: {
      fill: "#A0D468"
    },
    width: 213.18,
    height: 86.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.11,
    y: 245.14,
    style: {
      fill: "#A0D468"
    },
    width: 213.16,
    height: 86.29
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M266.447,362.404c0,5.87-4.762,10.647-10.647,10.647c-5.885,0-10.663-4.777-10.663-10.647 c0-5.902,4.777-10.68,10.663-10.68C261.686,351.724,266.447,356.502,266.447,362.404z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.623,
    y: 74.61,
    style: {
      fill: "#48CFAD"
    },
    width: 426.34,
    height: 149.21
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M170.523,458.329c-5.886,0-10.647,4.746-10.647,10.647c0,5.871,4.762,10.648,10.647,10.648h197.705 v-21.296L170.523,458.329L170.523,458.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M394.348,159.875H117.237c-5.886,0-10.664-4.778-10.664-10.664s4.778-10.647,10.664-10.647h277.111 c5.887,0,10.664,4.762,10.664,10.647C405.012,155.097,400.235,159.875,394.348,159.875z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.06,
    y: 191.85,
    style: {
      fill: "#48CFAD"
    },
    width: 147.67,
    height: 170.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.06,
    y: 362.4,
    style: {
      fill: "#A0D468"
    },
    width: 147.67,
    height: 88.02
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.274,170.538H351.725c-11.771,0-21.327,9.54-21.327,21.312v266.479 c0,11.772,9.556,21.296,21.327,21.296h138.549c11.787,0,21.326-9.523,21.326-21.296V191.85 C511.6,180.078,502.061,170.538,490.274,170.538z M490.274,458.329H351.725V191.85h138.549V458.329z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.59,
    y: 437,
    style: {
      fill: "#434A54"
    },
    width: 149.07,
    height: 26.886
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M431.584,458.329c0,5.87-4.777,10.647-10.663,10.647s-10.647-4.777-10.647-10.647 c0-5.901,4.762-10.679,10.647-10.679S431.584,452.428,431.584,458.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.267,287.776h-74.692c-5.885,0-10.663-4.778-10.663-10.648c0-5.901,4.778-10.648,10.663-10.648 h74.692c5.886,0,10.663,4.747,10.663,10.648C468.93,282.997,464.153,287.776,458.267,287.776z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service-1.bb25474569d433b8e5c7d84722afb079.svg";
export { ForwardRef as ReactComponent };